import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    tagDrawerContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 'calc(100% - 60px)'
    },
    tagDrawerBody: {
        overflowX: 'hidden',
        height: '100%',
        padding: 0
    },
    centerDrawerBody: {
        justifyContent: 'center'
    },
    hasTagsContainer: {
        marginTop: theme.spacing(3)
    },
    createTagButton: {
        color: theme.palette.common.black,
        borderColor: '#EDEEF0',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0, .08)',
            color: theme.palette.common.black,
            borderColor: '#EDEEF0'
        }
    },
    createTagButtonIcon: {
        width: 16,
        height: 16,
        '& svg path': {
            stroke: '#35373D'
        }
    }
}));
